module.exports = __webpack_public_path__ + "static/media/meniaga-icon-lightmode.c4add75c.png";